/** localhost with backend */
exports.development = {
  APP_PORT: 3000,
  MOCK_PORT: 4000,
  B2B_APP_PORT: 3010,
  B2B_MOCK_PORT: 8080,
  DAKTELA_GUI_TOKEN_CZ: 'o4psq2751r594r0366115834pq2s6r4q',
  DAKTELA_GUI_TOKEN_PL: 'po06305878987554219q2p824q505902',
}
